var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tect-post-list"},[_c('div',{staticClass:"tect-post-list__wrapper"},_vm._l((_vm.data),function(item){return _c('TechPostItem',{key:item.id,attrs:{"data":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }